export const MESSAGE_TYPE = {
  NOTIFICATION_PLANIFICATION: 'NOTIFICATION_PLANIFICATION',
};

export const MESSAGE_TYPE_DISPLAY = {
  [MESSAGE_TYPE.NOTIFICATION_PLANIFICATION]: 'Notification planification',
};
